import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CityDropdownForTrip, CommonInput, CommonModal, CustomPagination, CustomSelect } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteManufacturer, deleteStore, getManufacturerList, getPartCategoryList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { AddEditManufacturerModel } from 'modals';
import { utils } from 'helper';
import { getFirm } from '_services/accountsServices/firmServices';

const Firm = () => {
    useDocumentTitle("Firm | T360");
    const navigate = useNavigate()

    const { settingChild, masterData } = useContext(UserContext);
    const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");

    const [showFilterModal, setShowFilterModal] = useState(false);

    const [firmDataList, setFirmDataList] = useState([])
    const [loading, setLoading] = useState(false);
    const prevFilterRef = useRef();

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    const toggleFirmModelData = () => {
        navigate('/setting/firm/add')
    };

    const getDataFirmList = async () => {
        try {
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
            }
            const res = await getFirm(object);
            if (res?.responseCode == 200) {
                setFirmDataList(res?.data?.firms);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDataFirmList();
            prevFilterRef.current = filter;
        }
    }, [filter])

    const columns = [
        { header: "Firm Name", accessor: "name" },
        { header: "Mobile No.", accessor: "contact_no" },
        { header: "GST Type", accessor: "gst_type" },
        { header: "GST Number", accessor: "gst_number" },
        { header: "Action", accessor: "action" }
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            name: <span className='_tblText _style_ancer' onClick={() => navigate(`/setting/firm/details/${item?._id}`)}>
                <a className='_avPointer'>
                    {item?.firm ? item?.firm : '-'} &nbsp;
                </a>
            </span>,
            // navigate(`/setting/firm/add?name=details&id=${item?._id}`)
            contact_no: <>{item?.contact_no ? item?.contact_no : '-'}</>,
            gst_type: <>{item?.gst_type ? masterData?.gst_type[item?.gst_type] : '-'}</>,
            gst_number: <>{item?.gst_no ? item?.gst_no : '-'}</>,
            action: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "100px" }}>
                    <div className='_avPointer' onClick={() => navigate(`/setting/firm/add?name=details&id=${item?._id}`)}>
                        <span className='_samAnchor'>
                            <span className='viewIcon_avt'>
                                <AiOutlineEye color='green' />
                            </span>
                        </span>
                    </div>

                    <div className='_avPointer' onClick={() => navigate(`/setting/firm/add?name=edit&id=${item?._id}`)}>
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color='blue' />
                            </span>
                        </span>
                    </div>

                    {item?.is_default === 1 && <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            color: "#1450ec",
                        }}
                    >
                        <span>
                            <CiLock color="red" size={20} />
                        </span>
                    </div>}
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    return (
        <div className="__profilCmp_main setting-nw-parentBx">
            <ButtonHeading
                title={"Firm"}
                className="commonHeading_title"
                onClick={toggleFirmModelData}
                buttonTitle="+ Add Firm"
                showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={true}
            />

            <div className='pd_manufactoer'>
                <div className='__filtsTb_flexMain'>
                    <div className='__filtsTb_flex'>
                        <div className='__fInx_bx'>
                            <CommonInput
                                type="search"
                                label='Search Firms'
                                placeholder='Search Firms'
                                name='search'
                                value={filter.search}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    tableClass="nrml-tbl"
                    data={rowListData(firmDataList?.length > 0 ? firmDataList : [])}
                    isLoading={loading}
                />

                {firmDataList?.length ? <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div> : <></>}
            </div>

        </div >
    )
}

export default Firm